import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import {
  AdHocReportListResponse,
  AdHocReportRunRequest,
  AdHocReportRunResponse,
} from '@chiroup/core/types/AdHocReport.type';

const adHocReportService = () => {
  const runAdHocReport = async ({
    clinicId,
    body,
  }: {
    clinicId: number;
    body: AdHocReportRunRequest;
  }): Promise<AdHocReportRunResponse> => {
    return ChiroUpAPI.post('api', `/adhoc/${clinicId}/report`, {
      body,
    });
  };

  const listAdHocReportRuns = async ({
    clinicId,
  }: {
    clinicId: number;
  }): Promise<AdHocReportListResponse> => {
    return ChiroUpAPI.get('api', `/adhoc/${clinicId}/report`, {});
  };

  const getAdHocReportRun = async ({
    clinicId,
    runId,
  }: {
    clinicId: number;
    runId: string;
  }): Promise<AdHocReportRunResponse> => {
    return ChiroUpAPI.get('api', `/adhoc/${clinicId}/report/${runId}`, {});
  };

  const deleteAdHocReportRun = async ({
    clinicId,
    runId,
  }: {
    clinicId: number;
    runId: string;
  }): Promise<void> => {
    return ChiroUpAPI.del('api', `/adhoc/${clinicId}/report/${runId}`, {});
  };

  return {
    runAdHocReport,
    listAdHocReportRuns,
    getAdHocReportRun,
    deleteAdHocReportRun,
  };
};

export default adHocReportService();
